module.exports = __webpack_public_path__ + "img/undraw_warning_re_eoyh.872fdd7c.svg";